export default [{
    name: "Homer", 
    age: 37,
    tags: ["male", "adult", "stupid"]
}, {
    name: "Marge",
    age: 37,
    tags: ["female", "adult"]
}, {
    name: "Bart",
    age: 10,
    tags: ["male", "child", "stupid"],
}, {
    name: "Lisa",
    age: 8,
    tags: ["female", "child", "smart"]
}, {
    name: "Maggie",
    age: 2,
    tags: ["female", "baby", "smart"]
}, {
    name: "Grandpa",
    age: 78,
    tags: ["male", "elderly", "stupid"]
}];



// WEBPACK FOOTER //
// ./docs-src/demos/simpsons/data.ts